module.exports = __webpack_public_path__ + "static/media/album_cover.0118b59f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/album_cover.jpg
// module id = 180
// module chunks = 0